import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { client } from "../../api/client";
import { commonConstants } from "../../constants";
import { globalConstants } from "../../constants/global.constants";

const attendanceAdapter = createEntityAdapter();

const initialState = attendanceAdapter.getInitialState({
  status: globalConstants.IDLE,
  // fetchProject: projectsConstants.IDLE,
  attendance: {},
  breakLogs: {},
});

export const setCheckIn = createAsyncThunk(
  "attendance/setCheckIn",
  async (data) => {
    return await client.post("setCheckIn", data);
  }
);
// export const setAttendance = createAsyncThunk(
//   "attendance/setAttendance",
//   async (data) => {
//     return await client.post("setAttendance", data);
//   }
// );
export const setAttendance = createAsyncThunk(
  "attendance/setAttendance",
  async (data, thunkAPI) => {
    try {
      const response = await client.post("setAttendance", data);
      // console.log("setAttendance response", response);
      return response;
    } catch (error) {
      // console.error("setAttendance error", error);
      throw error;
    }
  }
);
const attendanceSlice = createSlice({
  name: "attendance",
  initialState,
  reducers: {},
  extraReducers: {
    [setAttendance.pending]: (state, action) => {
      state.status = globalConstants.LOADING;
    },
    [setAttendance.fulfilled]: (state, action) => {
      state.status = globalConstants.SUCCEEDED;
      state.attendance = action.payload["existingAttendance"];
      state.breakLogs = action.payload["newBreakLog"];
    },
    [setAttendance.rejected]: (state, action) => {
      state.status = globalConstants.ERROR;
    },
  },
});

export default attendanceSlice.reducer;
